import Locale from "@/helper/locale/Locale.js";
import Account from "@/helper/AccountHelper.js";
import BzbsProfile from "@/core/Account/service/BzbsProfile";

export default {
    data: function() {
        return {
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),
            locale: Locale,
        };
    },
    methods: {
        switchLang: function(locale) {
            this.locale.setLocale(locale);
            this.lbl = Locale.getLbl();
            this.localeCode = Locale.getLocaleCode();

            // let profile = this.$store.getters.getProfile;

            if (Account.isLogin()) {
                // Account.apiUpdateProfileLocale(locale, profile).then(() => {
                //     this.$store.commit("updateLocale", locale);
                //     window.location.reload();
                // }).catch(() => {
                //     window.location.reload();
                // });

                BzbsProfile.changeLocale(this.localeCode).subscribe({
                    next: (data) => {
                        console.log(data);
                        Account.updateToken(data.data);
                        window.location.reload();
                    },
                    error: (err) => {
                        console.log(err);
                    },
                })
            } else {
                window.location.reload();
            }
        }
    },
};
